<template>
  <edit-profile />
</template>

<script>
import EditProfile from '@/components/EditProfile'

export default {
  components: {
    EditProfile,
  },
}
</script>
